// src/pages/AdminImportador.js
import React, { useState } from 'react';
import './AdminImportador.css';
import { functions } from '../firebase'; // Importar a instância do Firebase Functions
import { httpsCallable } from "firebase/functions";

const AdminImportador = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [defaultImageUrl, setDefaultImageUrl] = useState('https://firebasestorage.googleapis.com/v0/b/pts-dev-br.firebasestorage.app/o/Intelbras%2Fintelbras-logo.png?alt=media&token=fa8b7a4a-1258-4472-a7ca-b7d219a0f55e');
  const [feedback, setFeedback] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };
  // Função para converter o arquivo para Base64
  const toBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(',')[1]); // Remove o prefixo "data:...;base64,"
    reader.onerror = (error) => reject(error);
  });

  const handleImport = async () => {
    if (!selectedFile) {
      alert('Por favor, selecione um arquivo de planilha.');
      return;
    }
    if (!defaultImageUrl.startsWith('http')) {
        alert('Por favor, insira uma URL válida para a imagem padrão.');
        return;
    }

    setIsLoading(true);
    setFeedback('Iniciando importação... Lendo o arquivo e enviando para o servidor. Isso pode levar alguns minutos.');

    try {
      // 1. Converte o arquivo para Base64
      const fileContentBase64 = await toBase64(selectedFile);

      // 2. Prepara a chamada para a Cloud Function
      const processarPlanilha = httpsCallable(functions, 'processarPlanilhaIntelbras');
      
      // 3. Executa a função passando os dados necessários
      const result = await processarPlanilha({
        fileContentBase64: fileContentBase64,
        defaultImageUrl: defaultImageUrl,
      });

      // 4. Exibe o resultado para o usuário
      setFeedback(result.data.message);

    } catch (error) {
      console.error("Erro ao chamar a função de importação:", error);
      setFeedback(`Erro: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="importador-container">
      <h1>Importador de Produtos em Massa</h1>
      <p className="subtitle">
        Faça o upload de uma planilha (.xlsx ou .csv) para cadastrar ou atualizar produtos de um fabricante.
      </p>

      <div className="importador-card">
        <div className="form-group">
          <label htmlFor="fabricante">1. Selecione o Fabricante</label>
          <select id="fabricante" name="fabricante" defaultValue="intelbras">
            <option value="intelbras">Intelbras</option>
            {/* Futuramente, poderemos adicionar outros fabricantes aqui */}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="defaultImageUrl">2. URL da Imagem Padrão</label>
          <input
            type="url"
            id="defaultImageUrl"
            name="defaultImageUrl"
            placeholder="https://.../imagem-padrao.jpg"
            value={defaultImageUrl}
            onChange={(e) => setDefaultImageUrl(e.target.value)}
          />
          <small>Esta imagem será usada para todos os produtos importados que não tiverem uma imagem específica.</small>
        </div>

        <div className="form-group">
          <label htmlFor="fileUpload">3. Selecione a Planilha</label>
          <input 
            type="file" 
            id="fileUpload" 
            name="fileUpload"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            onChange={handleFileChange}
          />
          {selectedFile && <p className="file-name">Arquivo selecionado: <strong>{selectedFile.name}</strong></p>}
        </div>

        <button onClick={handleImport} className="import-button" disabled={isLoading}>
          {isLoading ? 'Importando...' : 'Processar e Importar'}
        </button>

        {feedback && (
          <div className="feedback-area">
            <h4>Status da Importação:</h4>
            <pre>{feedback}</pre>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminImportador;